module.exports = __webpack_public_path__ + "static/media/try-today-image.570484c2.png";